interface LabelProps {
  type: 'live' | 'breaking' | 'analysis' | 'opinion' | 'explainer' | 'feature' | 'video';
  animate?: boolean;
}

const typeConfig: Record<LabelProps['type'], { bg: string; text: string; label: string }> = {
  live:      { bg: 'bg-[#C8102E]', text: 'text-white', label: 'LIVE' },
  breaking:  { bg: 'bg-[#C8102E]', text: 'text-white', label: 'BREAKING' },
  analysis:  { bg: 'bg-[#1A1A1A]', text: 'text-white', label: 'ANALYSIS' },
  opinion:   { bg: 'bg-[#1A4A8A]', text: 'text-white', label: 'OPINION' },
  explainer: { bg: 'bg-[#0C7A6E]', text: 'text-white', label: 'EXPLAINER' },
  feature:   { bg: 'bg-[#E07B00]', text: 'text-white', label: 'FEATURE' },
  video:     { bg: 'bg-[#2D2D2D]', text: 'text-white', label: 'VIDEO' },
};

export default function Label({ type, animate }: LabelProps) {
  const config = typeConfig[type];
  return (
    <span
      className={`inline-block ${config.bg} ${config.text} font-['IBM_Plex_Sans',system-ui,sans-serif] font-bold text-[10px] tracking-[0.1em] uppercase px-1.5 py-0.5 ${
        animate ? 'animate-live-pulse' : ''
      }`}
    >
      {config.label}
    </span>
  );
}
